import { Component } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-linea',
  templateUrl: './linea.component.html',
  styles: []
})
export class LineaComponent {

  public fileError: string = '';

  public lineChartData: Array<any> = [
    {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'},
    {data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B'},
    {data: [18, 48, 77,  9, 100, 27, 40], label: 'Series C'}
  ];

  public lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  public lineChartOptions: any = { responsive: true };

  public lineChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    {
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    {
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';

  public randomize(): void {
    const newData: Array<any> = this.lineChartData.map(series => ({
      label: series.label,
      data: series.data.map(() => Math.floor(Math.random() * 100) + 1)
    }));
    this.lineChartData   = [...newData];
    this.lineChartLabels = [...this.lineChartLabels];
  }

  /**
   * Formato esperado (hoja "Linea" o primera hoja):
   *   Fila 1: Series | January | February | ...   ← cabecera
   *   Fila 2: Ventas | 120     | 145      | ...   ← datos
   *   Fila 3: Costes | 80      | 90       | ...
   *   ...
   * Filas sin valores numéricos (notas, vacías) se ignoran automáticamente.
   */
  public loadFromExcel(event: any): void {
    this.fileError = '';
    const file = event.target.files[0];
    if (!file) { return; }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });

        const sheetName = workbook.SheetNames.find(
          n => n.toLowerCase() === 'linea'
        ) || workbook.SheetNames[0];

        const sheet = workbook.Sheets[sheetName];
        const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });

        if (rows.length < 2) {
          this.fileError = 'El archivo debe tener al menos una fila de cabecera y una de datos.';
          return;
        }

        // Row 0 is the header; skip it for data parsing but read labels from it
        const headerRow = rows[0];

        // Keep only data rows where at least one value after the first cell is numeric
        const dataRows = rows.slice(1).filter(row => {
          const values = row.slice(1);
          return values.some(v => v !== '' && v !== null && !isNaN(Number(v)));
        });

        if (dataRows.length === 0) {
          this.fileError = 'No se encontraron filas de datos válidos.';
          return;
        }

        // Detect format: if first cell of first data row is non-numeric → label column
        const firstCell    = dataRows[0][0];
        const firstIsLabel = isNaN(Number(firstCell)) && String(firstCell).trim() !== '';

        let newLabels: string[];
        let newChartData: Array<any>;

        if (firstIsLabel) {
          // FORMAT A: col 0 = series name, cols 1+ = values
          newLabels    = headerRow.slice(1).filter(v => v !== '').map(String);
          newChartData = dataRows.map((row, i) => ({
            label: String(row[0]) || `Series ${i + 1}`,
            data:  row.slice(1, newLabels.length + 1).map((v: any) => Number(v) || 0)
          }));
        } else {
          // FORMAT B: no label column
          newLabels    = headerRow.filter(v => v !== '').map(String);
          newChartData = dataRows.map((row: any[], i: number) => ({
            label: `Series ${i + 1}`,
            data:  row.slice(0, newLabels.length).map((v: any) => Number(v) || 0)
          }));
        }

        if (newChartData.length === 0 || newLabels.length === 0) {
          this.fileError = 'No se encontraron datos válidos.';
          return;
        }

        // New references force ng2-charts to re-render
        this.lineChartLabels = [...newLabels];
        this.lineChartData   = [...newChartData];

      } catch (err) {
        this.fileError = 'Error al leer el archivo Excel. Revisa el formato.';
        console.error(err);
      }
    };

    reader.readAsBinaryString(file);
    event.target.value = '';
  }

  public chartClicked(e: any): void { console.log(e); }
  public chartHovered(e: any): void { console.log(e); }

  constructor() {}
}